import booleanize from "./booleanize";

/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const normalize = (value: string | number | any) => {
  if (typeof value === "string") {
    // If it is a stringfied number.
    if (Number.isNaN(+value) === false) {
      return Number(value);
    } else {
      if (value === "true" || value === "false") {
        return booleanize(value);
      }
      if (value === "null") {
        return null;
      }
      if (value === "undefined") {
        return undefined;
      }
      return value.toLowerCase();
    }
  }
  return value;
};

export const isNumber = (value: string | number | any) => {
  const input = Number(value);
  return Number.isNaN(input) === false;
};

export function normalizeToCamelCase(str: string): string {
  const words = str.trim().toLowerCase().split(' ');
  return words
    .map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}


export default capitalize;
